import { render, staticRenderFns } from "./SearchInput.vue?vue&type=template&id=67153068&scoped=true"
import script from "./SearchInput.vue?vue&type=script&lang=js"
export * from "./SearchInput.vue?vue&type=script&lang=js"
import style0 from "./SearchInput.vue?vue&type=style&index=0&id=67153068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67153068",
  null
  
)

export default component.exports